import Swiper from "swiper";
import { Pagination } from 'swiper/modules';
import "swiper/css";

const fullScreenSlider = () => {
    const $container = document.querySelector('.pin-slider');

    if (!$container) return;

    const sliderContainer = $container.querySelector('.js-pin-slider');

    if (sliderContainer) {
        const swiper = new Swiper(sliderContainer, {
            modules: [Pagination],
            slidesPerView: 1,
            speed: 1000,
            pagination: {
                el: '.swiper-pagination-progressbar',
                type: 'progressbar',
            },
            on: {
                slideChange: function () {
                    updateCustomPagination(this.realIndex);
                    updateProgressBar(this.realIndex);
                },
            },
        });

        $container.querySelectorAll('.swiper-custom-pagination span').forEach(el => {
            el.addEventListener('click', () => {
                const index = parseInt(el.getAttribute('data-index'), 10);
                swiper.slideTo(index);
            });
        });

        function updateCustomPagination(activeIndex) {
            $container.querySelectorAll('.swiper-custom-pagination span').forEach((el, idx) => {
                el.classList.remove('active', 'completed', 'future');

                if (idx < activeIndex) {
                    el.classList.add('completed');
                } else if (idx === activeIndex) {
                    el.classList.add('active');
                    el.textContent = idx + 1;
                } else {
                    el.classList.add('future');
                    el.textContent = idx + 1;
                }
            });
        }

        function updateProgressBar(activeIndex) {
            const progressEl = $container.querySelector(".swiper-pagination-progressbar-fill");
            const totalSlides = swiper.slides.length;
            const percentage = ((activeIndex + 1) / totalSlides) * 100;
            progressEl.style.width = `${percentage}%`;
        }

        updateCustomPagination(0);
        updateProgressBar(0);
    }
};

export default fullScreenSlider;